var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cool-image-widget-container",on:{"click":_vm.handleClick}},[_c('ComponentWrap',{attrs:{"config":_vm.detail.config,"styles":_vm.detail.styles}},[_c('img',{staticClass:"img-item",attrs:{"src":_vm.imageSrc}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }